import "@rainbow-me/rainbowkit/styles.css";
import "./index.css";
import ReactDOM from "react-dom/client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { Global } from "@emotion/react";

import { config } from "@/constants/wagmi";
import AppRoutes from "./Routes";
import { BrowserRouter } from "react-router-dom";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { GlobalStyles } from "./constants/globalStyles";

// import VConsole from "vconsole";
// const vConsole = new VConsole();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <ChakraProvider>
    <Global styles={GlobalStyles} />
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <Box
          sx={{
            height: "100%",
            "&>div": {
              height: "100%",
            },
          }}
        >
          <RainbowKitProvider>
            <BrowserRouter>
              <AppRoutes></AppRoutes>
            </BrowserRouter>
          </RainbowKitProvider>
        </Box>
      </QueryClientProvider>
    </WagmiProvider>
  </ChakraProvider>
);
